import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import moment from 'moment-timezone';

@Component({
  selector: 'app-partial-entitling-document',
  templateUrl: './partial-entitling-document.component.html',
  styleUrls: ['./partial-entitling-document.component.scss'],
  standalone: false,
})
export class PartialEntitlingDocumentComponent {
  @Input() controls: { [key: string]: FormControl };
  @Input() minValidDate: moment.Moment;
  @Input() maxValidDate: moment.Moment;
  @Input() documentIssuePickerStartDate: moment.Moment;
}
